import Vue from 'vue'
import router from './router' //导入路由router
import store from './store' //引入store
import ElementUI from 'element-ui';
import './assets/base.css';
import './assets/common.css';
import 'element-ui/lib/theme-chalk/index.css';
import plugins from "./plugins"; // plugins
import App from './App.vue'
import PaginationComponent from "@/components/PaginationComponent";
import DictData from "@/components/DictData";
import { getToken } from "@/utils/auth";
import GSignInButton from 'vue-google-signin-button'
import i18n from './components/i18n'

Vue.use(GSignInButton);

router.beforeEach((to, from, next) => {
    if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆


        if (getToken()) { // 查询本地存储信息是否已经登陆
            next();
        } else {
            // 直接跳转到登录页面，不显示弹窗
            next({
                path: '/login', // 未登录则跳转至login页面
                query: {
                    redirect: to.fullPath
                }
                // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
            });
        }
    } else {
        next();
    }
})
Vue.component("PaginationComponent", PaginationComponent);
export const EventBus = new Vue()
Vue.prototype.$bus = EventBus;
Vue.use(ElementUI);
Vue.use(plugins);
DictData.install();
Vue.config.productionTip = false

store.dispatch('InitRegionContext').catch(() => {}).finally(() => {
    new Vue({
        router, //在vue实例中使用router
        i18n,
        render: h => h(App),
        store
    }).$mount('#app')
})
